
import React, {useEffect, useState} from "react";
import MusicDashboard from '../../layouts/musicDashboard';
import AccountNav from '../../elements/accountElements/accountNav'; 
import config from '../../config/config';
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
// import NumberFormat from 'react-number-format';
import { PatternFormat } from 'react-number-format';

import Spinner from 'react-bootstrap/Spinner';   
import InputGroup from 'react-bootstrap/InputGroup';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import {connect} from 'react-redux';
import * as subscriptionAction from '../../store/subscription/actions'
import * as couponAction from '../../store/coupon/actions';
import * as commonActions from '../../store/common/actions';

import { CanAddApplePay } from './canAddApplePay';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './checkoutForm'
import { API_BASE_URL } from '../../services/config';
// published key
// const stripePromise = loadStripe("pk_test_51SfEVcIicspwD0nqRVbXLgR2N8dzHozlz3qdxOoU9iqiYYJ0mqj5nbUGWUfkddFLvZp2XQpmb0czMbZk3t6h3rFX00DJ9zSuCE");
const stripePromise = loadStripe("pk_live_51OLGLVIGZoAJE3zoNZ9pjfcJOh35nAjKJgpySzh30wPuu6OVWxr5h2ZAclDRESR8QnkY0HI5HTvzzrZDfqvJUukw00C8ax3Qs2");


const PaymentMethod = ({ loggingIn, displayLoading, hideLoading, getDealServices, getServices, plans, validateCoupon, getCustomerAgreement, agreement, processCardPaymentMethod, processPaypalPayment, getPlanDetails, customerProfile, subscriptionDetail, processApplePayment, getCountryList, countryList, activeCoupon }) => {
    
    let match = useParams("/subscription/payment-method/:plan_id");
    let matchCoupon = useParams("/subscription/payment-method/:plan_id/:coupon");
    
    const location = useLocation();
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal)
    const [ planId, setPlanId ] = useState();
    const [ subscriptionData, setSubscriptionData ] = useState();
    const [ paymentMethod, setPaymentMethod ] = useState();
    const [ couponCode, setCouponCode ] = useState();
    const [inputValue, setInputValue] = useState('');
    const [ coupon, setCoupon ] = useState();
    const [region, setRegion] = useState();
    const [isCountrySelected, setIsCountrySelected] = useState(false);
    const [formDataEnter, setFormDataEnter] = useState(false);
    const [ formSubmited, setForrmSubmited ] = useState(false);
    const [formData, setFormData] = useState({
        card_number: '',
        card_type: "",
        expire_date: '',
        ccv: '', 
        payment_method: '', 
        terms_condition: '',
        street:'',
        city:'',
        state: '',
        zip_code:'',
        country:''
    });
    const visaTypeOptions = [
        {label: "Visa", value: "Visa"},
        {label: "MasterCard", value: "MasterCard"},
        {label: "Discover", value: "Discover"},
        {label: "Amex", value:"Amex"}
    ];
    const [ processCardPayment, setProcessCardPayment ] = useState(false);
    const [ errors, setErrors ] = useState({});
    const [ validated, setValidated] = useState(false);
    const [ couponApplied, setCouponApplied ] = useState(false);
    const [ selectedPlan, setSelectedPlan] = useState();
    const [ value, setValue] = useState();
    const [processCoupon, setProcessCoupon ] = useState(false)
    const [couponValidationError, setCouponValidationError] = useState();
    const [ isStaff, setIsStaff ] = useState(false)
    const [setupIntentClientSecret, setSetupIntentClientSecret] = useState(null);
    const [proceedToCheckout, setProceedToCheckout] = useState(false);
    
    // Check if user is on Windows or Linux (hide Google Pay option for all browsers on these OS)
    const isWindowsOrLinux = () => {
        if (typeof window === 'undefined') return false;
        const userAgent = navigator.userAgent;
        const isWindows = /Windows/.test(userAgent);
        const isLinux = /Linux/.test(userAgent) && !/Android/.test(userAgent);
        return isWindows || isLinux;
    };
    const [hideGooglePay, setHideGooglePay] = useState(false);

    useEffect(() => {  
		if(loggingIn !== undefined && loggingIn === false){
            navigate('/sign-in');
		} 
    },[])
    
    useEffect(() => {
        // Check if Google Pay should be hidden (any browser on Windows/Linux)
        setHideGooglePay(isWindowsOrLinux());
    }, []);
    
    useEffect(() => { 
		// load Page Data
        validateCoupon({coupon_code: '', subscription_id: match.plan_id})
		loadPageData();
    },[]);
    
    useEffect(() => { 
        getCountryList();
    },[]);

    useEffect(() => { 
        if(customerProfile && formDataEnter === false){
            setFormData({
                // firstname: customerProfile && customerProfile.firstname ? customerProfile.firstname : '',
                // lastname: customerProfile && customerProfile.lastname ? customerProfile.lastname : '',
                // street: customerProfile && customerProfile.street ? customerProfile.street : '',
                // country_id: customerProfile && customerProfile.country_id ? customerProfile.country_id : '',
                // region_id: customerProfile && customerProfile.region_id ? customerProfile.region_id : '',
                // city: customerProfile && customerProfile.city ? customerProfile.city : '',
                postcode: customerProfile && customerProfile.postcode ? customerProfile.postcode : '',
                email: customerProfile && customerProfile.email ? customerProfile.email : '',
                // dj_name: customerProfile && customerProfile.dj_name ? customerProfile.dj_name : '',
            });
            setFormDataEnter(true);
            setInputValue(customerProfile && customerProfile.city ? customerProfile.city : '')
        }
        if(isCountrySelected == false && customerProfile &&  countryList && countryList.length > 0){
            const selectedCountry = countryList.find((element) => {
                return element.id === customerProfile.country_id;
            });
            if(selectedCountry && selectedCountry.region){
                setRegion(selectedCountry.region)
                setIsCountrySelected(true);
            }
            
            
        }
    },[customerProfile])
    
    useEffect(() => { 
        // alert('hi')
		if(match.plan_id) {
            setPlanId(match.plan_id)
        } else if (matchCoupon.plan_id && matchCoupon.coupon){
            setPlanId(matchCoupon.plan_id);
            setCouponCode(matchCoupon.coupon);
        } else {
            navigate("/subscription/plans");
        }
    },[location]);
    
    useEffect(() => { 
        if(activeCoupon && activeCoupon.coupon_code){ 
		    setCoupon(activeCoupon);
        }
    },[activeCoupon]);

    useEffect(() => {
        if(customerProfile && customerProfile.group_id == 3){
            
            var d1 = new Date();
            var d2 = new Date(customerProfile.staff_membership_expire_date);
            if(d2.getTime() > d1.getTime()){
                setIsStaff(true);
            }
        }
    },[customerProfile]);

    // Profile is already created and paymment processing then redirect them to plan page
    if(agreement && agreement.profile_status == 'CREATED'){
        navigate('/subscription/plans');
    }

    const loadPageData = async() => {
        
        displayLoading();
        if(match.plan_id == 42){
            await getServices({subscription_type_id: 1}).then((res) => {
                if(res && res.payload && res.payload.data && res.payload.status == 'true'){
                    let selectedPlanFromRes = res.payload.data.find(  service  => service.id ==  match.plan_id);
                    setSelectedPlan(selectedPlanFromRes);                    
                    getPlanDetails({coupon: coupon,  subscription: selectedPlanFromRes}).then(res => {
                    
                    })
                }
            });
        } else {
            if(matchCoupon.plan_id && matchCoupon.coupon){
                validateCoupon({coupon_code: matchCoupon.coupon.toUpperCase(), subscription_id: matchCoupon.plan_id}).then((res)=>{
                    if(res && res.payload && res.payload.data && res.payload.data.status && res.payload.status == 'true'){
                        setCoupon(res.payload.data);
                        setCouponApplied(true);
                        getPlanDetails({coupon: res.payload.data,  subscription: {id: matchCoupon.plan_id}}).then(res => {
                            setSelectedPlan(res.payload.data)
                        })
                    
                    } else {
                        setCoupon('');
                        setCouponApplied(false);
                        setCouponValidationError(res.payload.message.errors[0]);
                        // Swal.fire({
                        //     icon: 'error',
                        //     title: "Invalid Coupon!", 
                        //     text: res.payload.message.errors[0],
                        //     type: "error", 
                        //     closeOnConfirm: true
                        // }, function(){
                            
                        // });
                    }
                });
            } else {
                await getDealServices({subscription_type_id: 1}).then((res) => {
                    
                    if(res && res.payload && res.payload.data && res.payload.status == 'true'){
                        let selectedPlanFromRes = res.payload.data.find(  service  => service.id ==  match.plan_id);
                        setSelectedPlan(selectedPlanFromRes);
                        getPlanDetails({coupon: coupon,  subscription: selectedPlanFromRes}).then(res => {
                        
                        })
                    }
                })
            }
        }
        await getCustomerAgreement();
        
        hideLoading();
        window.scrollTo({top: 0});
    }
    // console.log(selectedPlan)
    const setPromoCode = (event) => {
        const { name, value } = event.target;
        setCouponCode(value)
    }

    const checkCoupon = async() => {
        if(couponCode){
            setProcessCoupon(true);
            // call Validate coupon code
            await validateCoupon({coupon_code: couponCode, subscription_id: planId}).then((res)=>{
                if(res && res.payload && res.payload.data && res.payload.data.status && res.payload.status == 'true'){
                    setCoupon(res.payload.data);
                    setCouponApplied(true);
                    getPlanDetails({coupon: res.payload.data,  subscription: selectedPlan}).then(res => {
                        setSelectedPlan(res.payload.data)
                    })
                   
                } else {
                    setCoupon('');
                    setCouponApplied(false);
                    setCouponValidationError(res.payload.message.errors[0]);
                    // Swal.fire({
                    //     icon: 'error',
                    //     title: "Invalid Coupon!", 
                    //     text: res.payload.message.errors[0],
                    //     type: "error", 
                    //     closeOnConfirm: true
                    // }, function(){
                        
                    // });
                }
            });
            setProcessCoupon(false);
           
            // setCouponApplied(true)
        } else {
            // Swal.fire({
            //     icon: 'error',
            //     title: "Invalid Coupon!", 
            //     text: 'Please enter coupon code',
            //     type: "error", 
            //     closeOnConfirm: true
            // }, function(){
                
            // });
            setCouponValidationError('Please enter coupon code');
        }
    }

    // console.log('coupon', coupon)

    const processPayment = async (formData) => { 
        displayLoading();
        setProcessCardPayment(true);
        if(paymentMethod && paymentMethod == 'credit_card') {
            await processCardPaymentMethod({formData: formData, coupon: coupon,  subscription: selectedPlan}).then(res => {
                if(res && res.payload && res.payload.data){
                    setForrmSubmited(false);
                    setProcessCardPayment(false);
                    window.location.href = '/subscription/success/complete';
                } else {
                    setForrmSubmited(false);
                    setProcessCardPayment(false);
                    Swal.fire({
                        icon: 'error',
                        title: "Transcation Failed!", 
                        text: res.payload.message.errors[0],
                        type: "error", 
                        closeOnConfirm: true
                    }, function(){
                        
                    });
                    
                }
            });
            hideLoading();
            setProcessCardPayment(false);
        } else if(paymentMethod && paymentMethod == 'paypal') {
            let purchasePlan = selectedPlan;
            purchasePlan.payment_method = paymentMethod;
            
            await processPaypalPayment({subscription: purchasePlan, coupon: coupon}).then((res) => {
                if(res && res.payload && res.payload.data && res.payload.data.status && res.payload.status == 'true'){
                    hideLoading();
                    window.location.href = res.payload.data.paypal;
                    setProcessCardPayment(false);
                }
            });
        } else if(paymentMethod && paymentMethod == 'mobile_wallet') {
            await getPlanDetails({coupon: coupon,  subscription: selectedPlan}).then(res => {
                hideLoading();
                setProcessCardPayment(false);
                navigate(`/subscription/in-app-payment/${planId}`)
            })
        }
    }

    const getCardType = (number) => {
        const re = {
          visa: /^4/,
          mastercard: /^(5[1-5]|2[2-7])/,
          amex: /^3[47]/,
          discover: /^6(?:011|5)/,
          diners: /^3(?:0[0-5]|[68])/,
          jcb: /^(?:2131|1800|35)/,
        };
      
        if (re.visa.test(number)){
            return 'Visa';
        }
        if (re.mastercard.test(number)){
            return 'MasterCard';
        }
        if (re.amex.test(number)){ 
            return 'Amex'
        } 
        if (re.discover.test(number)){
            return 'Discover';
        }
        return '';
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Create updated formData with the new value
        const updatedFormData = {
            ...formData,
            [name]: value
        };
        
        if(name == 'card_number'){ 
            updatedFormData.card_type = getCardType(value);
        }
        
        setFormData(updatedFormData);

        if(name === 'country_id'){
            const selectedCountry = countryList.find((element) => {
                return element.id === value;
            });
            if(value != ''){
                setRegion(selectedCountry.region);
            }
        }
        
        if(name == 'postcode'){
            if ( value.length < 3  || value.length > 7){
                setErrors({
                    ...errors,
                    postcode: 'Zip Code should be atleast 3 and maximum 7 digit!'
                });
            } else {
                setErrors({
                    ...errors,
                    postcode: ''
                });
            } 
        }
           
        if(name == 'payment_method'){
            setPaymentMethod(value);
            setForrmSubmited(false);
            // Reset proceed to checkout when payment method changes
            setProceedToCheckout(false);
            // Clear setup intent when payment method changes
            setSetupIntentClientSecret(null);
            
            // Validate and clear errors if both payment method and terms are valid
            if (value && (value === 'credit_card' || value === 'mobile_wallet')) {
                // Use updatedFormData to get the current terms condition value (since formData state update is async)
                const currentTermsCondition = updatedFormData.terms_condition;
                const isTermsChecked = currentTermsCondition === '1' || currentTermsCondition === true || (currentTermsCondition && currentTermsCondition !== '');
                if (isTermsChecked) {
                    // Both are valid, clear errors and proceed
                    setErrors({
                        ...errors,
                        payment_method: '',
                        terms_condition: ''
                    });
                    setProceedToCheckout(true);
                    // If mobile_wallet, fetch setup intent
                    if (value === 'mobile_wallet') {
                        getPlanDetails({coupon: coupon,  subscription: selectedPlan}).then(res => {
                            fetch(API_BASE_URL + 'stripe/create-setup-intent.json')
                                .then(res => res.json())
                                .then(data => {
                                    if (data.data && data.data.client_secret) {
                                        setSetupIntentClientSecret(data.data.client_secret);
                                        console.log('Setup Intent clientSecret received for Express Checkout');
                                    }
                                })
                                .catch(err => {
                                    console.error('Error fetching Setup Intent:', err);
                                });
                        });
                    }
                } else {
                    // Payment method selected but terms not checked, clear payment method error only
                    setErrors({
                        ...errors,
                        payment_method: ''
                    });
                }
            } else {
                // Clear payment method error
                setErrors({
                    ...errors,
                    payment_method: ''
                });
            }
        }
        
        // If Terms & Conditions is checked, validate both and proceed if valid
        if(name == 'terms_condition'){
            if (value && (value === '1' || value === true)) {
                // Terms checked
                if (paymentMethod && (paymentMethod === 'credit_card' || paymentMethod === 'mobile_wallet')) {
                    // Both are valid, clear errors and proceed
                    setErrors({
                        ...errors,
                        payment_method: '',
                        terms_condition: ''
                    });
                    setProceedToCheckout(true);
                    // If mobile_wallet, fetch setup intent
                    if (paymentMethod === 'mobile_wallet') {
                        getPlanDetails({coupon: coupon,  subscription: selectedPlan}).then(res => {
                            fetch(API_BASE_URL + 'stripe/create-setup-intent.json')
                                .then(res => res.json())
                                .then(data => {
                                    if (data.data && data.data.client_secret) {
                                        setSetupIntentClientSecret(data.data.client_secret);
                                        console.log('Setup Intent clientSecret received for Express Checkout');
                                    }
                                })
                                .catch(err => {
                                    console.error('Error fetching Setup Intent:', err);
                                });
                        });
                    }
                } else {
                    // Terms checked but payment method not selected, clear terms error only
                    setErrors({
                        ...errors,
                        terms_condition: ''
                    });
                }
            } else {
                // Terms unchecked, reset proceed to checkout
                setProceedToCheckout(false);
                setSetupIntentClientSecret(null);
                // Clear terms error
                setErrors({
                    ...errors,
                    terms_condition: ''
                });
            }
        }
        if(formSubmited && paymentMethod && paymentMethod == 'credit_card'){
            const newErrors = findFormErrors();
            setErrors(newErrors)
        }
    }

    const findFormErrors = () => {
        const {  card_number, expire_date, ccv, payment_method, terms_condition, card_type, firstname, lastname, street, country_id, region_id, postcode, city } = formData
        const newErrors = {}
        if(payment_method && payment_method == 'credit_card'){
            // if ( !cardholder_name || cardholder_name === '' ) newErrors.cardholder_name = 'Card Holder Name cannot be blank!'
            if ( !card_number || card_number === '' ) newErrors.card_number = 'Card Number cannot be blank!'
            if ( !expire_date || expire_date === '' ) newErrors.expire_date = 'Expire Date cannot be blank!'
            if ( !ccv || ccv === '' ) newErrors.ccv = 'CCV cannot be blank!'
            if(!card_type || card_type === '') newErrors.card_type = 'Select card type'
            // if ( !firstname || firstname === '' ) newErrors.firstname = 'First Name cannot be blank!'
            // if ( !lastname || lastname === '' ) newErrors.lastname = 'Last Name cannot be blank!'
            // if ( !country_id || country_id === '' ) newErrors.country_id = 'Country cannot be blank!'
            // if ( !region_id || region_id === '' ) newErrors.region_id = 'State cannot be blank!'
            // if ( !city || city === '' ) newErrors.city = 'City cannot be blank!'
            if ( !postcode || postcode === '' ) newErrors.postcode = 'Zip Code cannot be blank!'
            if ( postcode && postcode.length < 3  || postcode.length > 7){
                newErrors.postcode = 'Zip Code should be atleast 3 and maximum 7 digit!'
            } 
            // if ( !street || street === '' ) newErrors.street= 'Address cannot be blank!'
        
        }
        
        if( !payment_method || payment_method === '')  newErrors.payment_method = 'Select a payment method'
        
        // Require Terms & Conditions for credit card and mobile wallet (Apple Pay) payment methods
        if((payment_method === 'credit_card' || payment_method === 'mobile_wallet') && (!terms_condition || terms_condition === '')) {
            newErrors.terms_condition = 'Terms & Condition is required'
        }

        return newErrors
    }
    const handleSubmit = (event) => { 
        const newErrors = findFormErrors();
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setForrmSubmited(true);
        // console.log('formData', formData)
        // console.log('newErrors', newErrors)
        if ( Object.keys(newErrors).length > 0 ) {
            // We got errors!
            setErrors(newErrors);
            setForrmSubmited(false);
        } else {
            processPayment(formData);
        }
    }

    const displayTermsCondition = () => {
        MySwal.fire({
            title: "<div class='terms-title'>Terms & Condition</div>",
            html: "<div class='terms-content'><p>Before proceeding you must agree to Club Killers, Inc terms and conditions</p>"+
            "<ul>"+
            "<li>You agree each bill is automatically deducted from your checking or savings account based on your selected plan. You’ll never be bothered with having to remember to pay your bill. Club Killers takes care of it for you, even when you’re away on vacation.</li>"+
            "<li>It is your responsibility to: Ensure there are sufficient funds available in your checking or savings account to meet each withdrawal on the due date. If there are insufficient funds in your account, your financial institution may charge you a fee and/or interest. You are solely responsible for paying any fee and/or interest charged by your financial institution.</li>"+
        "</ul></div>",
            type: "info",
            allowOutsideClick: false,
        });
    }

    const processWalletPayment = (event, coupon) => {
        console.log('processWalletPayment called with event:', event);
        console.log('Payment method ID:', event.paymentMethod?.id);
        console.log('Subscription detail:', subscriptionDetail);
        console.log('Coupon:', coupon);
        
        // `event` is the full Payment Request event from Stripe
        processApplePayment({
            payment_method: event.paymentMethod.id, 
            coupon: coupon, 
            subscription: subscriptionDetail, 
            subscription_id: subscriptionDetail?.id
        }).then( res => {
            console.log('processApplePayment response:', res);
            console.log('Response payload:', res?.payload);
            console.log('Response data:', res?.payload?.data);
            console.log('Response status:', res?.payload?.data?.status);
            
            if(res && res.payload && res.payload.data && res.payload.data.success && res.payload.data.success == true){
                console.log('Payment successful:', res.payload.data);
                event.complete('success');
                // navigate(`/subscription/success/${res.payload.data.agreement.stripe_subscription_id}`);
                navigate(`/subscription/success/complete`)
            } else {
                console.error('Payment failed - response:', res);
                console.error('Payment failed - payload:', res?.payload);
                console.error('Payment failed - data:', res?.payload?.data);
                event.complete('fail');
                navigate(`/subscription/payment-failed`);
            }
            
        }).catch((error) => {
            console.error('processApplePayment error:', error);
            console.error('Error response:', error?.response);
            event.complete('fail');
            navigate(`/subscription/payment-failed`);
        });
    }
    
    return (
        <MusicDashboard middleSectionCssClass={"account-info-sec full-section"}>
            <div className="content-sec">
                <div className="account-block">
                    <div className="top-heading">
                        <h2>Account Setting</h2>
                    </div>
                    <AccountNav/> 
                    <div className="account-inner-block">
                        {
                            agreement && agreement.profile_status == 'Active' ?
                                <div class="announcement-bar position-relative" style={{textAlign: 'center', fontWeight: '700'}}>
                                    {/* <p>ATTENTION: You are currently running an active subscription. Your new subscription will be applied immediately and will cancel your current subscription.</p>  */}
                                    <p>ATTENTION: You have landed on wrong page. You already have an active subscription.</p>
                                </div>
                            : 
                        
                            isStaff ? <div className="alert alert-danger">You have landed on wrong page. Please contact to <a href="mailto: info@clubkillers.com" className="text-3">Support</a> for more details</div>
                        :
                        <div className="subscription-sec m-auto payment-method-sec">
                        <div className="top">
								<h5>Hi, {customerProfile.dj_name}! You haven't subscribed yet</h5>
								<h1>Choose your payment method</h1>
								<p className="text-3">Please review your membership details and billing information to complete your order.</p>
							</div>
							<div className="payment-block">
                                
								<div className="left">
                                    <Form  validated={validated} onSubmit={handleSubmit}>
									<div className="pay-sec">
										<h5>Select payment method</h5>
							                {!hideGooglePay && (
                                                <Form.Check 
                                                    name="payment_method"
                                                    type="radio" 
                                                    className=""
                                                    id={`wallet`}
                                                    label={'Apple Pay' }
                                                    onChange={handleChange} 
                                                    value="mobile_wallet" 
                                                    isInvalid={ !!errors.payment_method }
                                                    
                                                />
                                            )}
                                            {/* <Form.Check 
                                                    name="payment_method"
                                                    type="radio"
                                                    id={`paypal`}
                                                    label={'PayPal'}
                                                    onChange={handleChange}
                                                    value="paypal"
                                                    isInvalid={ !!errors.payment_method }
                                                /> */}
                                            <Form.Check 
                                                    name="payment_method"
                                                    type="radio"
                                                    id={`creditcard`}
                                                    label={'Credit Card'}
                                                    onChange={handleChange}
                                                    value="credit_card" 
                                                    isInvalid={ !!errors.payment_method }
                                                />
                                            
									</div>
                                    {
                                        paymentMethod && paymentMethod == 'paypal' ?
                                            <div className="paypal-payment">
                                                <span>We'll redirect you to PayPal to complete your purchase.</span>
                                            </div>
                                        : ''
                                    }
                                    <Form.Control.Feedback type="invalid">
                                        { errors.payment_method }
                                    </Form.Control.Feedback>
                                    
                                    {/* Show Terms & Conditions checkbox by default */}
                                    <div className="custominput">
                                        <Form.Check 
                                            value="1"
                                            type='checkbox'
                                            id={`terms-vondition`}
                                            onChange={handleChange}
                                            name="terms_condition"
                                            label={<span className="text-5" >By Checking, you accept our  <span onClick={() => displayTermsCondition()}>Terms & Conditions</span>.</span>} 
                                            isInvalid={ !!errors.terms_condition }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            { errors.terms_condition }
                                        </Form.Control.Feedback>
                                    </div>
                                    
                                    {/* Show "Proceed to checkout" button only if both are not valid */}
                                    {(() => {
                                        const isPaymentMethodSelected = paymentMethod === 'credit_card' || paymentMethod === 'mobile_wallet';
                                        const isTermsChecked = formData.terms_condition === '1' || formData.terms_condition === true || (formData.terms_condition && formData.terms_condition !== '');
                                        const bothValid = isPaymentMethodSelected && isTermsChecked;
                                        
                                        // Hide button if proceedToCheckout is true OR both are valid
                                        const shouldHideButton = proceedToCheckout || bothValid;
                                        
                                        // Show button only if it should not be hidden
                                        return !shouldHideButton;
                                    })() && (
                                        <button 
                                            type="button"
                                            className="primary-btn m" 
                                            onClick={() => {
                                                // Validate payment method is selected
                                                if (!paymentMethod || paymentMethod === '') {
                                                    setErrors({
                                                        ...errors,
                                                        payment_method: 'Select a payment method'
                                                    });
                                                    return;
                                                }
                                                
                                                // Validate Terms & Conditions is checked (only for credit_card and mobile_wallet)
                                                if ((paymentMethod === 'credit_card' || paymentMethod === 'mobile_wallet') && (!formData.terms_condition || formData.terms_condition === '')) {
                                                    setErrors({
                                                        ...errors,
                                                        terms_condition: 'Terms & Condition is required'
                                                    });
                                                    return;
                                                }
                                                
                                                // Clear any previous errors
                                                setErrors({
                                                    ...errors,
                                                    payment_method: '',
                                                    terms_condition: ''
                                                });
                                                
                                                setProceedToCheckout(true);
                                                // If mobile_wallet, fetch setup intent
                                                if (paymentMethod === 'mobile_wallet') {
                                                    getPlanDetails({coupon: coupon,  subscription: selectedPlan}).then(res => {
                                                        fetch(API_BASE_URL + 'stripe/create-setup-intent.json')
                                                            .then(res => res.json())
                                                            .then(data => {
                                                                if (data.data && data.data.client_secret) {
                                                                    setSetupIntentClientSecret(data.data.client_secret);
                                                                    console.log('Setup Intent clientSecret received for Express Checkout');
                                                                }
                                                            })
                                                            .catch(err => {
                                                                console.error('Error fetching Setup Intent:', err);
                                                            });
                                                    });
                                                }
                                            }}
                                        >
                                            Proceed to checkout
                                        </button>
                                    )}
                                    
                                    {/* Show payment form/button only after "Proceed to checkout" is clicked */}
                                    {proceedToCheckout && (
                                        <>
                                            {subscriptionDetail && paymentMethod === 'mobile_wallet' ?   
                                                setupIntentClientSecret ? (
                                                    <Elements stripe={stripePromise} options={{
                                                        clientSecret: setupIntentClientSecret, 
                                                        appearance: {theme: 'stripe'},
                                                        currency: String(subscriptionDetail?.currency || subscriptionDetail?.currency_code || 'USD').toLowerCase()
                                                    }}>
                                                        <CanAddApplePay subscriptionData={subscriptionDetail} coupon={coupon} onConfirmPayment={processWalletPayment} />
                                                    </Elements>
                                                ) : (
                                                    <div className="" style={{textAlign: 'center'}}><Spinner animation="border" size="sm" variant="dark" /></div>
                                                )
                                            : null
                                            }
                                        </>
                                    )}
                                    
                                    {/* Show submit button for credit card after proceeding to checkout */}
                                    {/* {proceedToCheckout && paymentMethod === 'credit_card' && (
                                        formSubmited ? 
                                            <button disabled="disabled" type="button" className="primary-btn"><Spinner animation="border" size="sm" variant="dark" /></button> 
                                            : <button type="submit" className="primary-btn">Proceed to payment</button>
                                    )} */}
                                </Form>
                                {
                                    paymentMethod && paymentMethod == 'credit_card' && proceedToCheckout ? 
                                        <Elements stripe={stripePromise}>
                                            <CheckoutForm customer={customerProfile} subscription={subscriptionDetail} coupon={coupon} />
                                        </Elements> 
                                    : ''
                                }
                                    
								</div>
                                
                                
                                { 
                                    selectedPlan ? 
								    <div className="right">
                                        <div className="your-plan box">
                                            { 
                                                
                                                <div className="top">
                                                    <h2>Your plan</h2>
                                                    { coupon && coupon.discount_amount > 0 ? <h2>Total: ${selectedPlan.price} - ${coupon.discount_amount} = ${selectedPlan.price - coupon.discount_amount}</h2> : selectedPlan.trial_interval && selectedPlan.trial_price ? <h2>Total: ${selectedPlan.trial_price}</h2>:<h2>Total: ${selectedPlan.price}</h2> }
                                                </div>
                                            }
                                            <div className="body-text">
                                                <span className="text-2">Starting Today:</span>
                                                {
                                                    selectedPlan.trial_length && selectedPlan.trial_price ?
                                                        <span className="text-3">${selectedPlan.trial_price} First {selectedPlan.trial_length == 1 ? '' : selectedPlan.trial_length} {selectedPlan.trial_period != 'Day' ? selectedPlan.trial_period : 'Month'} thereafter ${selectedPlan.price} every {selectedPlan.payment_interval == 30 ? '' : selectedPlan.payment_interval} {selectedPlan.payment_period != 'Day' ? selectedPlan.payment_period : 'Month'}.</span>
                                                    : 
                                                
                                                        coupon && coupon.coupon_code == 'SPOOKY' ? 
                                                        coupon && coupon.discount_amount > 0 ? <span className="text-3">${selectedPlan.price - coupon.discount_amount} first {selectedPlan.payment_interval == 365 ? 'year' : 'month'} thereafter ${selectedPlan.price} every {selectedPlan.payment_interval == 365 ? 'year' : 'month'}</span> :  <span className="text-3">${selectedPlan.price} first {selectedPlan.payment_interval} {selectedPlan.payment_period}s</span>
                                                        : 
                                                            coupon && coupon.discount_amount > 0 ? <span className="text-3">${selectedPlan.price - coupon.discount_amount} every {selectedPlan.payment_interval} {selectedPlan.payment_period}</span> : <span className="text-3">${selectedPlan.price} every {selectedPlan.payment_interval} {selectedPlan.payment_period}s</span>
                                                }
                                                <br />
                                                <span className="text-2">Billing detail:</span>
                                                {
                                                    selectedPlan.trial_interval && selectedPlan.trial_price ?
                                                        <span className="text-3">${selectedPlan.trial_price} First {selectedPlan.trial_length == 1 ? '' : selectedPlan.trial_length} {selectedPlan.trial_period != 'Day' ? selectedPlan.trial_period : 'Month'} thereafter ${selectedPlan.price} every {selectedPlan.payment_interval == 30 ? '' : selectedPlan.payment_interval} {selectedPlan.payment_period != 'Day' ? selectedPlan.payment_period : 'Month'}.</span>
                                                    : 
                                                    selectedPlan?.trial?.trial_length ? 
                                                        <span className="text-3 as">${selectedPlan.trial.trial_price} First {selectedPlan.trial.trial_length == 1 ? '' : selectedPlan.trial.trial_length} {selectedPlan.trial.trial_period != 'Day' ? selectedPlan.trial.trial_period : 'Month'} thereafter ${selectedPlan.amount} every {selectedPlan.payment_interval == 30 ? '' : selectedPlan.payment_interval} {selectedPlan.payment_period != 'Day' ? selectedPlan.payment_period : 'Month'}.</span>
                                                    :                                               
                                                    coupon && coupon.coupon_code == 'SPOOKY' ? 
                                                        coupon && coupon.discount_amount > 0 ? <span className="text-3">${selectedPlan.price - coupon.discount_amount} first {selectedPlan.payment_interval == 365 ? 'year' : 'month'} thereafter ${selectedPlan.price} every {selectedPlan.payment_interval == 365 ? 'year' : 'month'}</span> :  <span className="text-3">${selectedPlan.price} every {selectedPlan.payment_interval} {selectedPlan.payment_period}s.</span>
                                                    :
                                                        coupon && coupon.discount_amount > 0 ? <span className="text-3">${selectedPlan.price - coupon.discount_amount} every {selectedPlan.payment_interval} {selectedPlan.payment_period}s.</span> : <span className="text-3">${selectedPlan.price} every {selectedPlan.payment_interval} {selectedPlan.payment_period}s.</span>
                                                }
                                            </div>
                                            <p className="text-5">Cancel anytime. <a href="#">Offer term</a> apply</p>
                                        </div>
                                        <div className="box promo-apply">
                                            <h2>Have a promo code?</h2>
                                            <div className="form-content">
                                                {couponValidationError && couponValidationError != '' ? <div class="alert alert-danger">{couponValidationError}</div> : ''}
                                                <InputGroup className="form-group">
                                                    <Form.Label className="text-5">Promotion code</Form.Label>
                                                    <FormControl
                                                        placeholder="Have a Promo Code?"
                                                        aria-label="Promo Code"
                                                        className="text-3 form-control" 
                                                        onChange={setPromoCode}
                                                        onFocus={() => setCouponValidationError('')}
                                                    />
                                                </InputGroup>
                                            </div>
                                            { couponApplied == true && coupon ? <p>Discount <span className="text-danger">${coupon.discount_amount}</span> applied {couponApplied}</p> : ''}
                                            { couponApplied == true ? <InputGroup.Text className="border-0 bg-none px-2 ">{processCoupon ? <button className="secondary-btn"><Spinner animation="border" size="sm" variant="dark" /></button> : <button className="secondary-btn" onClick={() => checkCoupon()}>Change</button>}</InputGroup.Text> : ''}
                                            { couponApplied == false ? processCoupon ? <button className="secondary-btn"><Spinner animation="border" size="sm" variant="dark" /></button> :<button className="secondary-btn" onClick={() => checkCoupon()}>Apply</button> : ''}
                                        </div>
								    </div>
                                     : ''
                                }
							</div>
                        </div>
                    }
                    </div>
                </div>
            </div>
        </MusicDashboard>
    );
}
function mapStateToProps(state) {
  return {
	agreement: state.subscription.agreement,
    plans: state.subscription.plans,
    customerProfile: state.customer.customerProfile,
    subscriptionDetail: state.subscription.subscriptionDetail,
    countryList: state.common.countryList,
    activeCoupon: state.coupon.coupon,
    loggingIn: state.authentication.loggedIn,
  };
}

function mapDispatchToProps(dispatch) {
  	return {
        getCountryList: () => dispatch(commonActions.getCountryList()),
        getServices: (post) => dispatch(subscriptionAction.getServices(post)),
        getDealServices: (post) => dispatch(subscriptionAction.getDealServices(post)),
        validateCoupon: (post) => dispatch(couponAction.validateCoupon(post)),
        getCustomerAgreement: () => dispatch(subscriptionAction.getCustomerAgreement()),
        processCardPaymentMethod: (post) => dispatch(subscriptionAction.processCardPaymentMethod(post)),
        processPaypalPayment: (post) => dispatch(subscriptionAction.processPaypalPayment(post)),
        getPlanDetails: (post) => dispatch(subscriptionAction.getPlanDetails(post)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        processApplePayment: (post) => dispatch(subscriptionAction.processApplePayment(post))
  	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethod);